import React, { useContext } from "react";
import { deepCopy } from "../../utils";
import { TableContext } from "../../index";
import { Checkbox } from "../../view/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { MoreVertical, Eye } from 'lucide-react';


function ConfigChangesTableRow({ data, index }) {

    const { config, setConfig } = useContext(TableContext);

    const onCheckboxChange = () => {
        let selectedRows = deepCopy(config.selected);
        if (selectedRows.includes(data.id)) {
            selectedRows.splice(selectedRows.indexOf(data.id), 1);
        } else {
            selectedRows.push(data.id)
        }
        setConfig({ ...config, selected: selectedRows })
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    // This function formats a bigint timestamp into "DD MMM YYYY, HH:MM"
    const getDateTimeFormat = (bigIntTime) => {
        if (!bigIntTime) return '';

        const datetime = Number(bigIntTime); // convert bigint/string to number
        const date = new Date(datetime);

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day} ${month} ${year}, ${hours}:${minutes}`;
    }

    return (
        <tr key={index}>
            <td>
                <Checkbox checked={config.selected.includes(data.id)} onClick={() => onCheckboxChange()} />
            </td>
            <td>{data.device}</td>
            <td>{data.ip}</td>
            <td>{data.user}</td>
            <td>{getDateTimeFormat(data.changeDate)}</td>
            <td>
                <button className="oct_dropdown-trigger-v2" onClick={handleClick}>
                    <MoreVertical className="oct_icon" />
                </button>

                <Menu
                    className="oct_menu-v2"
                    id="action-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>

                    <MenuItem className="oct_menu-item-v2" onClick={handleClose}>
                        <Eye className="oct_icon" /> View Details
                    </MenuItem>

                </Menu>
            </td>
        </tr>
    );

}


export default ConfigChangesTableRow;
